import type { NewCustomDimension } from "domains/dimension/dimension.types";

export enum CustomKeyIssueTypes {
  CREATE = "[Custom Key Issue] - Create",
  CREATE_FULFILLED = "[Custom Key Issue] - Create - Fulfilled",
  CREATE_REJECTED = "[Custom Key Issue] - Create - Rejected",
  ACTIVATE_FORM = "[Custom Key Issue] - Activate Form",
}

export type CreateCustomKeyIssueDefaultAction = { meta: NewCustomDimension; type: CustomKeyIssueTypes.CREATE };
export type CreateCustomKeyIssueFulfilledAction = {
  payload: { dimensionId?: string };
  type: CustomKeyIssueTypes.CREATE_FULFILLED;
};
export type CreateCustomKeyIssueRejectedAction = { type: CustomKeyIssueTypes.CREATE_REJECTED };

export type ActivateCreateFormAction = {
  meta?: { id?: string; isActive?: boolean };
  type: CustomKeyIssueTypes.ACTIVATE_FORM;
};

export type CustomKeyIssueAction =
  | CreateCustomKeyIssueDefaultAction
  | CreateCustomKeyIssueFulfilledAction
  | CreateCustomKeyIssueRejectedAction
  | ActivateCreateFormAction;
